<template>
  <div class="login-page">
    <div class="login-page-title">
      <div class="login-image">
        <img src="@/assets/image/logo (2).png" alt="logo图">
      </div>
      <!--<div class="login-text">-->
      <!--<img src="@/assets/image/walema.png" alt="logo图" class="login-text-image">-->
      <!--<span class="login-title">商家后台管理系统</span>-->
      <!--</div>-->
    </div>
    <div class="login-information">
      <div class="login-information-image">
        <img src="@/assets/image/beijing1.png" alt="" class="image">
      </div>
      <div class="login-information-tabs">
        <a-tabs @change="callback">
          <a-tab-pane tab="账号登录" key="1">
            <div class="account-login">
              <a-input placeholder="请输入用户账号或手机号" v-model="loginData.userName" ref="userNameInput"
                @pressEnter="pressEnter" :class="!isLoginSucceed?'user-name-input' :''">
                <img slot="prefix" src="@/assets/image/yong_hu.png" alt="" class="input-img" v-if="isLoginSucceed">
                <img slot="prefix" src="@/assets/image/yong_hu_cuo.png" alt="" class="input-img" v-else>
              </a-input>
              <a-input-password placeholder="请输入正确的登录密码" v-model="loginData.password" @pressEnter="pressEnter"
                ref="userNameInput">
                <img slot="prefix" src="@/assets/image/mi_ma.png" alt="" class="input-img">
              </a-input-password>
              <div class="verify-code" v-if="loginNum>2">
                <a-input placeholder="请输入验证码" v-model="loginData.verifyCode" @pressEnter="pressEnter"
                  ref="userNameInput">
                  <img slot="prefix" src="@/assets/image/yan_zheng.png" alt="" class="input-img">
                </a-input>
                <div class="code-box">
                  <!-- <verify :identifyCode="verifyCode" :contentHeight="46" :contentWidth="120"></verify> -->
                  <img :src="verifyCodeBase64" alt="" style="width: 120px; height: 46px">
                  <span class="change-code" @click="changeCode">换一张</span>
                </div>
              </div>
              <div class="password-operation">
                <a-checkbox :checked="isCheck" @change="onChange">记住密码</a-checkbox>
                <span @click="btnChangePassword" style="cursor: pointer;">忘记密码</span>
              </div>
              <a-button type="primary" :loading="$store.state.isLoding" @click="btnLogin" class="ant-btn-primary-login">
                登录</a-button>
              <!-- <div class="agreement">
                <a-checkbox @change="onChangeAgreementChecked" :checked="agreementChecked">阅读并同意《服务协议和隐私政策》</a-checkbox>
              </div> -->
              <!-- <div class="experience">
                <span @click="getExperienceAccount">开启体验之旅</span>
                <img src="@/assets/image/login_experience.png" alt="跳转" class="experience-img"
                  @click="getExperienceAccount">
              </div> -->
            </div>
          </a-tab-pane>
          <!-- <a-tab-pane tab="扫码登录" key="2">
            <div class="login-code">
              <div class="qrcode-box">
                <a-spin :spinning="spinning">
                  <qrcode :swidth="150" :pathCode="qrCodePath" v-if="activeKey==2"></qrcode>
                </a-spin>
                <div class="lose-efficacy" v-if="isrefresh">
                  <span>二维码失效</span>
                  <a-button type="primary" icon="sync" @click="btnRefresh" class="ant-btn-primary-login">重新刷新</a-button>
                </div>
              </div>
              <div class="qrcode-text">
                <a-icon type="scan" class="a-icon" />
                <span class="text">打开手机版商家后台管理系统 扫一扫登录</span>
              </div>
            </div>
          </a-tab-pane> -->
        </a-tabs>
      </div>
    </div>
    <div class="login-page-footer">
    </div>
    <change-password ref="setPassword"></change-password>
    <experience ref="experience"></experience>
  </div>
</template>

<script>
// import qrcode from "@/components/qrcode.vue";
// import verify from "@/components/verify.vue";
import changePassword from "./changePassword";
import experience from "./experience";
import { mapActions } from "vuex";
import {
  getVerifyCode,
  login,
  getAccountList,
  getJurisdiction,
} from "@/utils/api";
let Base64 = require("js-base64").Base64;
export default {
  name: "login",
  components: {
    // verify,
    // qrcode,
    changePassword,
    experience,
  },
  data() {
    return {
      isLoginSucceed: true,
      qrCodePath: "",
      isrefresh: false,
      timer: null,
      activeKey: 1,
      spinning: false,
      loginData: {
        verifyCode: "",
        verifyKey: "",
        userName: "",
        password: "",
      },
      verifyCodeBase64: "",
      isCode: false,
      loginNum: 0,
      isCheck: false,
      agreementChecked: true,
    };
  },
  mounted() {
    // 清除缓存
    sessionStorage.clear();
    // 获取可视区域高度
    // this.boxHeigght = (document.body.scrollHeight - 660) / 2;
    if (localStorage.getItem("loginNum")) {
      this.changeCode();
      this.loginNum = localStorage.getItem("loginNum");
    }
    this.getCookie();
    // 绑定enter事件
    this.enterKeyup();
    // token失效时是否弹出重新登陆框的表示
    sessionStorage.setItem("tokenFailure", true);
  },
  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  methods: {
    ...mapActions({ add_Routes: "add_Routes" }),
    enterKey(event) {
      const componentName = this.$options.name;
      if (event.keyCode == 13) {
        this.btnLogin();
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
    // 切换登录方法
    callback(key) {
      if (key == 2) {
        this.spinning = true;
        this.getQrCode();
      } else {
        this.activeKey = 1;
        clearInterval(this.timer);
      }
    },
    // 记住7天密码
    onChange(e) {
      this.isCheck = e.target.checked;
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie("", "", false, -1);
    },
    //设置cookie
    setCookie(username, password, isCheck, exdays) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      // 字符串拼接cookieexdate
      document.cookie =
        "userName" +
        "=" +
        Base64.encode(username) +
        ";expires=" +
        exdate.toUTCString() +
        "; path=/";
      document.cookie =
        "userPwd" +
        "=" +
        Base64.encode(password) +
        ";expires=" +
        exdate.toUTCString() +
        "; path=/";
      document.cookie =
        "isCheck" +
        "=" +
        isCheck +
        ";expires=" +
        exdate.toUTCString() +
        "; path=/";
    },
    getCookie() {
      let rememberData = {};
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); // 再次切割
          // // 判断查找相对应的值
          if (arr2[0] === "userName") {
            rememberData.userName = arr2[1]; // 保存到保存数据的地方
          } else if (arr2[0] === "userPwd") {
            rememberData.password = arr2[1];
          } else if (arr2[0] === "isCheck") {
            this.isCheck = arr2[1] == "true";
          }
        }
        if (this.isCheck) {
          this.loginData.userName = Base64.decode(rememberData.userName); // 保存到保存数据的地方
          this.loginData.password = Base64.decode(rememberData.password);
        } else {
          this.loginData = {
            userName: null,
            password: null,
            isCheck: false,
          };
          this.clearCookie();
        }
      }
    },
    onChangeAgreementChecked(e) {
      this.agreementChecked = e.target.checked;
    },
    // 切换验证码
    changeCode() {
      let header = {
        token: "",
      };
      let params = {};
      getVerifyCode(params, header).then((res) => {
        if (res.success) {
          this.loginData.verifyKey = res.result.verifyKey;
          this.verifyCodeBase64 = res.result.verifyCodeBase64;
        }
      });
    },
    // 开始登录
    btnLogin() {
      if (
        this.isEmpty(this.loginData.userName) ||
        this.isEmpty(this.loginData.password)
      ) {
        this.$message.warn("请先输入账户和密码");
        return;
      } else if (!this.agreementChecked) {
        this.$message.warn("请先阅读并同意《服务协议和隐私政策》");
        return;
      }
      let params = {};
      if (this.loginNum > 2) {
        params = this.$qs.stringify({
          verifyCode: this.loginData.verifyCode.replace(/^\s*|\s*$/g, ""),
          verifyKey: this.loginData.verifyKey,
          userName: this.loginData.userName.replace(/^\s*|\s*$/g, ""),
          password: this.$md5(
            this.loginData.password.replace(/^\s*|\s*$/g, "")
          ),
        });
      } else {
        params = this.$qs.stringify({
          userName: this.loginData.userName.replace(/^\s*|\s*$/g, ""),
          password: this.$md5(
            this.loginData.password.replace(/^\s*|\s*$/g, "")
          ),
        });
      }
      let header = {
        token: "",
      };
      this.$store.state.isLoding = true;
      login(params, header).then((res) => {
        if (res.success) {
          this.$store.state.token = res.result.value;
          getAccountList({}).then((res) => {
            if (res.success) {
              if (this.isCheck) {
                this.setCookie(
                  this.loginData.userName,
                  this.loginData.password,
                  this.isCheck,
                  365
                );
              } else {
                this.clearCookie();
              }
              if (res.result.length == 1) {
                let params = new FormData();
                params.append("accountId", res.result[0].accountId);
                params.append("storeId", res.result[0].companyStoreId);
                getJurisdiction(params).then((response) => {
                  if (response.success) {
                    if (response.result.permissionForm.length == 0) {
                      this.$message.warn("亲，你没有分配菜单的权限哦~");
                      return;
                    }
                    if (this.isEmpty(response.result.storeType)) {
                      this.$store.state.storeType = 1;
                    } else {
                      this.$store.state.storeType = response.result.storeType;
                    }
                    localStorage.setItem(
                      "storeType",
                      this.$store.state.storeType
                    );
                    this.add_Routes(response.result.permissionForm);
                    this.$store.state.oneMenuNum = 0;
                    this.$store.state.menuId =
                      response.result.permissionForm[0].children[0].children[0].accountId;
                    sessionStorage.setItem(
                      "routes",
                      JSON.stringify(response.result.permissionForm)
                    );
                    this.$router.replace({
                      path: "/systemoverview/overview/home",
                    });
                    this.$store.state.shopId = res.result[0].companyStoreId;
                    this.$store.state.companyId = response.result.companyId;
                    // 保持登录后一级菜单在首页
                    sessionStorage.setItem("oneMenuNum", 0);
                    // 保留登录信息
                    res.result[0].companyId = response.result.companyId;
                    this.$store.state.userInfo = res.result[0];
                    sessionStorage.setItem(
                      "accountType",
                      res.result.accountType
                    );
                    sessionStorage.setItem(
                      "userInfo",
                      JSON.stringify(res.result[0])
                    );
                    sessionStorage.setItem(
                      "btnPermissions",
                      JSON.stringify(response.result.buttonLable)
                    );
                  } else {
                    this.$message.warn(res.logMessage);
                  }
                });
              } else {
                this.$router.replace({ path: "/shop" });
              }
            } else {
              this.$message.warn(res.logMessage);
            }
          });
          localStorage.removeItem("loginNum");
        } else {
          this.loginNum = res.result;
          localStorage.setItem("loginNum", this.loginNum);
          if (3 > this.loginNum) {
            this.changeCode();
          }
          this.$message.warn(res.logMessage);
        }
        this.$store.state.isLoding = false;
      });
    },
    // 按下enter键开始登录
    pressEnter() {
      this.btnLogin();
    },
    // 扫码登录登录
    getQrCode() {
      //   this.$http.get('/login/qrcode', true).then(res => {
      //     this.countdown(60)
      //     this.qrCodePath = res.data.data[this.coun].path
      //     setInterval(() => {
      //       this.activeKey = 2
      //       this.spinning = false
      //     }, 200)
      //   })
      this.qrCodePath = "扫码登录平台";
      setInterval(() => {
        this.activeKey = 2;
        this.spinning = false;
      }, 200);
    },
    //  发送成功，开启倒计时
    countdown(codetime) {
      // 发送成功，开启倒计时
      this.timer = setInterval(() => {
        codetime--;
        if (codetime < 1) {
          clearInterval(this.timer);
          codetime = 0;
          this.isrefresh = true;
        }
      }, 1000);
    },
    // 刷新验证码
    btnRefresh() {
      this.getQrCode();
      this.isrefresh = false;
      this.spinning = true;
    },
    // 忘记密码
    btnChangePassword() {
      this.$refs.setPassword.show();
    },
    // 获取体验账号
    getExperienceAccount() {
      this.$refs.experience.show();
    },
  },
};
</script>
<style lang="scss">
.login-page {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  .login-page-title {
    height: 25vh;
    display: flex;
    align-items: flex-end;
    padding: 0 0 25px 184px;
    background-color: #ffffff;
    .login-image {
      width: 268px;
      height: 64px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .login-text {
      height: 32px;
      display: flex;
      align-items: flex-end;
      font-size: 21px;
      color: #f76f14;
      .login-text-image {
        height: 32px;
        margin: 0 20px;
      }
    }
  }
  .login-information {
    height: 50vh;
    background-image: url("../../assets/image/beijing.png");
    display: flex;
    align-items: center;
    justify-content: center;
    .login-information-image {
      width: 512px;
      height: 424px;
      .image {
        width: 512px;
        height: 424px;
      }
    }
    .login-information-tabs {
      width: 492px;
      min-height: 466px;
      background-color: #ffffff;
      margin-left: 140px;
      padding: 35px 65px 45px 65px;
    }
    .ant-tabs-bar {
      margin: 0 !important;
      border-color: rgba(239, 246, 255, 0.24);
      .ant-tabs-nav-container {
        height: 70px;
      }
      .ant-tabs-tab {
        font-size: 20px;
        color: #888888;
        padding: 8px 0px !important;
      }
      .ant-tabs-tab-active {
        color: #333333;
        font-size: 26px;
      }
      .ant-tabs-ink-bar {
        height: 3px;
      }
    }
    .account-login {
      margin-top: 30px;
      .user-name-input {
        .ant-input {
          border-color: #fd5621;
          color: #fd5621;
          border-radius: 2px !important;
        }
      }
      .ant-input {
        border-radius: 2px !important;
      }
      .ant-input-affix-wrapper {
        width: 360px;
        height: 46px;
        margin-bottom: 16px;
        .input-img {
          width: auto;
          height: 20px;
        }
        .ant-input:not(:first-child) {
          border-radius: 0;
          padding-left: 40px;
        }
      }
      .password-operation {
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        .ant-checkbox-wrapper {
          font-size: 16px;
          line-height: 18px;
          .ant-checkbox-inner {
            width: 18px;
            height: 18px;
          }
        }
      }
      .experience {
        color: #f76f14;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 16px;
        cursor: pointer;
        .experience-img {
          width: 18px;
          height: 18px;
          margin-left: 10px;
        }
      }
      .verify-code {
        display: flex;
        justify-content: space-between;
        .ant-input-affix-wrapper {
          width: 230px;
          height: 46px;
          margin-bottom: 16px;
        }
        .code-box {
          width: 218px;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .change-code {
            font-size: 14px;
            cursor: pointer;
            padding-left: 10px;
          }
        }
      }
      .ant-btn-primary-login {
        width: 360px;
        height: 46px;
        border-radius: 0;
        font-size: 18px;
        margin-top: 48px;
        background-color: var(--co);
        border-radius: 2px !important;
      }
      .agreement {
        color: #888888;
        margin-top: 15px;
      }
    }
    .login-code {
      height: 271px;
      padding: 38px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .qrcode-box {
        width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        position: relative;
        .lose-efficacy {
          width: 200px;
          height: 200px;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.8);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .ant-btn-primary-login {
            width: 150px;
            height: 40px;
            border-radius: 6px;
            margin-top: 10px;
          }
        }
      }
      .qrcode-text {
        height: 26px;
        color: #555555;
        display: flex;
        align-items: center;
        .a-icon {
          font-size: 26px;
          color: #f76f14;
        }
        .text {
          font-size: 16px;
          padding-left: 10px;
        }
      }
    }
  }

  .login-page-footer {
    height: 25vh;
    background-color: #ffffff;
  }

  input::-webkit-input-placeholder {
    color: #5e83b0;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #5e83b0;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #5e83b0;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #5e83b0;
  }
  .ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
    font-size: 18px;
    color: #5e83b0;
  }
  .ant-input:hover {
    // border-color: #5E83B0;
  }
}
@media screen and(max-height: 850px) {
  .login-page-title {
    height: 20vh !important;
  }
  .login-information {
    height: 60vh !important;
  }
  .login-page-footer {
    height: 20vh !important;
  }
}
</style>
